// Resolves once every <img> inside container has finished loading (or
// failed — either way, "settled") AND the page's webfonts have finished
// loading. Needed before window.print()/PDF capture: otherwise a
// signed-URL image whose network fetch hasn't completed yet (logo,
// watermark, signature, stamp) silently prints blank, with no error — and
// separately, printing before a custom font (Playfair Display, Inter)
// finishes loading renders that text in the browser's fallback font
// instead, which measures taller/wider and can push a tightly-fit
// single-page document (like InvoiceDocument, sized to just fit one A4
// page) over the edge into an unwanted second page.
export function waitForImages(container: HTMLElement): Promise<void> {
  const images = Array.from(container.querySelectorAll('img'));
  return Promise.all([
    document.fonts.ready,
    ...images.map(
      (img) =>
        new Promise<void>((resolve) => {
          if (img.complete) {
            resolve();
            return;
          }
          img.addEventListener('load', () => resolve(), { once: true });
          img.addEventListener('error', () => resolve(), { once: true });
        }),
    ),
  ]).then(() => undefined);
}
